<template>
  <lf-card class="mb-8 max-w-(--breakpoint-md) py-6">
    <loader :is-loading="isSubmitting" />
    <form @submit.prevent="onSubmit">
      <div class="my-2 space-y-2">
        <lf-h3>{{ $t("INTEGRATIONS.BRAND") }} {{ $t("COMMON.NAME") }}</lf-h3>
        <span class="mt-2">
          {{ $t("ORGANIZATION.BRAND_NAME") }}
        </span>
        <lf-input
          v-model="initialValues.brand_name"
          name="brand_name"
          type="text"
          class="py-3"
        />
        <div class="flex justify-end border-t pt-6">
          <modal-buttons
            class="bg-white"
            :disabled="isSubmitting"
            :save-button-text="$t('COMMON.SAVE_CHANGES')"
            save-is-submit
          />
        </div>
      </div>
    </form>
  </lf-card>
</template>

<script setup lang="ts">
import { reactive } from "vue";

import { useForm } from "vee-validate";

import { dispatchAction } from "@/helpers/vee-validate";
import { useClients } from "@/hooks/clients";

import ModalButtons from "@/components/ui/ModalButtons.vue";

const { activeClient } = useClients();

const initialValues = reactive({
  brand_name: activeClient.value?.brand_name,
});

const { handleSubmit, isSubmitting } = useForm({
  initialValues,
});

const onSubmit = handleSubmit(async (values, actions) => {
  // errors are handled in dispatchAction
  await dispatchAction({ data: values }, actions, "clients/updateClient");
});
</script>
